import csi from "csi/main";
import { TableComparisonData } from "csi/table/TableComparisonData";
import { TableWidget } from "csi/table/Widget";
import { ATTR_NAME, C8Node, cnl } from "csi/typings";
import xml from "csi/xml";
import _ from "lodash";

const URL_ATTR = "$URL";

interface BOMColorCompareData {
	/** colors in current view that are not in the comparison view */
	newColorUrls: cnl[];

	/** colors in comparison view that are not in the current view */
	oldColorUrls: cnl[];
}

export function compareBomColors(compareData: TableComparisonData, colors: C8Node[]): BOMColorCompareData {
	const { addColumnUrlMapping, compareByColorwayName, compareView, currentView: { cacheView }, isSameMaster } = compareData;
	const differentMasterId = compareByColorwayName ? ATTR_NAME : "ColorSpecification";
	const colorId = isSameMaster ? URL_ATTR : differentMasterId;
	const comparisonColorUrls = getMatrixUrls(compareView, "PartMaterialColors");
	const comparisonColors = cacheView.getNodes(comparisonColorUrls);
	const newColors = _.differenceBy(colors, comparisonColors, colorId);
	const oldColors = _.differenceBy(comparisonColors, colors, colorId);
	const newColorUrls = newColors.map(xml.nodeGetURL);
	const oldColorUrls = oldColors.map(xml.nodeGetURL);

	// create mapping from comparison color unique id to the comparison color
	const comparisonColorMap = csi.hashArray(comparisonColors, colorId, URL_ATTR);

	// add mapping for colors in current view
	for (const color of colors) {
		const value = color[colorId];
		addColumnUrlMapping(color.$URL, comparisonColorMap[value]);
	}

	// add mapping for old colors in comparison view
	for (const { $URL } of oldColors) {
		addColumnUrlMapping($URL, $URL);
	}

	return {
		newColorUrls,
		oldColorUrls,
	};
}

/** return true if given color is in the current view but not in the comparison view */
export function isNewCompareColor(data: BOMColorCompareData, colorUrl: cnl): boolean {
	return data.newColorUrls.includes(colorUrl);
}

/** return true if given color is in the comparison view but not in the current view */
export function isOldCompareColor(data: BOMColorCompareData, colorUrl: cnl): boolean {
	return data.oldColorUrls.includes(colorUrl);
}

/** Return column urls in given matrix */
function getMatrixUrls(view: TableWidget, matrixId: string): cnl[] {
	const urls: cnl[] = [];

	view.columnData.traverse(false, (c) => {
		if (c.heading?.m_id === matrixId) {
			urls.push(c.columnUrl);
		}
	});

	return urls;
}
